import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 50,
      },
    {
        title:Util.L('PackageNo'),
        width: 170,
        key:'packageNo'
    },
    {
        title:Util.L('Status'),
        width: 170,
        key:'statusName'
    },
    {
        title:Util.L('CreatorUserName'),
        width: 150,
        key:'creatorUserName'
    },
    {
        title:Util.L('CreationTime'),
        width: 150,
        key:'creationTime',
        render:(h:any,params:any)=>{
            if(!Util.isNull(params.row.creationTime))
                return h("span", Util.toViewDateString(params.row.creationTime));
            return '';
        }
    },
    {
        title:Util.L('GroupPackageCode'),
        width: 150,
        key:'deliveryPackageGroupCode'
    },
    {
        title:Util.L('HandoverSessionCode'),
        width: 150,
        slot:'handoversession'
    },
    {
        title:Util.L('HandoverUserName'),
        width: 150,
        key:'handoverUserName'
    },
    {
        title:Util.L('HandoverTime'),
        width: 150,
        key:'handoverTime',
        render:(h:any,params:any)=>{
            if(!Util.isNull(params.row.handoverTime))
                return h("span", Util.toViewDateString(params.row.handoverTime));
            return '';
        }
    },
    {
        title: Util.L('Action'),
        width:100,
        slot: 'action',
        align: 'center'
    }

]